import { ScreenReaderNotifier } from '@/components/ScreenReaderNotifier'
import { BodyM, HeadingS } from '@/components/Typography'

import { useElementAutoFocus } from '@/hooks/useElementAutoFocus'

import { useFgtsLoanSimulator } from '../../core/context'

import * as Simulation from './styles'

interface SalaryFieldProps {
  shouldFocus: boolean
}

export const SalaryField = ({ shouldFocus }: SalaryFieldProps) => {
  const { salaryRef, monthsWorkedRef } = useFgtsLoanSimulator()
  const elementRefToBeFocused = useElementAutoFocus(!shouldFocus)

  return (
    <div ref={elementRefToBeFocused}>
      <ScreenReaderNotifier
        enabled={!shouldFocus}
        allowSuppressOtherElements={false}
        label="Informe o valor em reais do seu salário"
      />
      <HeadingS html="Qual é o valor do seu salário?" />
      <BodyM html="Informe o valor em reais do seu salário:" />
      <Simulation.CurrencyField
        placeholder="R$ 0,00"
        aria-label="Digite o valor em reais do seu salário"
        maxLength={20}
        ref={salaryRef}
      />
      <Simulation.SalaryFieldWrapper>
        <HeadingS html="Há quanto tempo você está nesse emprego?" />
        <BodyM html="Informe há quantos meses você está neste emprego:" />
        <Simulation.TextField
          min={0}
          type="number"
          inputMode="numeric"
          aria-label="Digite quantos meses você está neste emprego"
          id="months-field"
          maxLength={4}
          placeholder="0 meses"
          ref={monthsWorkedRef}
          required
        />
      </Simulation.SalaryFieldWrapper>
    </div>
  )
}
